@if (displayValue) {
  <div class="field-card">
    <span class="field-label">{{ question.label }}</span>
    <span class="field-value">{{ displayValue }}</span>
  </div>
}
